export default __webpack_public_path__ + "bd98610e395f3b4c7915cf3fbe854f6f.js";